module.exports = __webpack_public_path__ + "static/media/case2.47507299.png";